import { UserPreference } from '@kaligo/hermes';
import {
  UserPreferenceAction,
  UserPreferenceActionTypes,
} from '../actions/user-preference.actions';

export interface UserPreferenceState extends UserPreference {}

const initialState: UserPreferenceState = {};

export function userPreferenceReducer(
  state: UserPreferenceState = initialState,
  action: UserPreferenceAction,
): UserPreferenceState {
  switch (action.type) {
    case UserPreferenceActionTypes.UPDATE_LOCALE_SUCCESS: {
      return {
        ...state,
        locale: action.payload.code,
      };
    }
    case UserPreferenceActionTypes.INITIALISE_USER_PREFERENCES:
      return {
        ...state,
        ...action.payload,
      };
    case UserPreferenceActionTypes.UPDATE_POINTS_ACCOUNT_ID_SUCCESS:
      return {
        ...state,
        pointsAccountId: action.payload,
      };

    default: {
      return {
        ...state,
      };
    }
  }
}
